import React from 'react';
import { cn } from './cn';

// Microscopic uppercase eyebrow that precedes major headings.
export function Eyebrow({ children, className }) {
    return <span className={cn('eyebrow', className)}>{children}</span>;
}

// Neutral pill tag.
export function Tag({ children, className, tone = 'neutral' }) {
    const tones = {
        neutral: 'bg-espresso/[0.06] text-espresso-soft ring-espresso/10',
        sage:    'bg-sage/15 text-sage-deep ring-sage/25',
        brass:   'bg-brass/15 text-brass-deep ring-brass/25',
    };
    return (
        <span className={cn('inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ring-1', tones[tone], className)}>
            {children}
        </span>
    );
}

// Payment/payout status pill. paid -> sage, pending -> brass/amber.
export function StatusPill({ status, paidLabel = 'Đã thanh toán', pendingLabel = 'Chờ thanh toán', className }) {
    const isPaid = status === 'paid';
    return (
        <span className={cn(
            'inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold ring-1',
            isPaid ? 'bg-sage/15 text-sage-deep ring-sage/25' : 'bg-brass/15 text-brass-deep ring-brass/25',
            className,
        )}>
            <span className={cn('h-1.5 w-1.5 rounded-full', isPaid ? 'bg-sage-deep' : 'bg-brass')} />
            {isPaid ? paidLabel : pendingLabel}
        </span>
    );
}
